module.exports = __webpack_public_path__ + "static/media/success.86c35de2.svg";